/* Extracted 2026-07-18 from snippets/bundle-selector.liquid's inline
 * <script> (~20KB per PDP HTML). Loaded with defer from theme.liquid on
 * product templates. The QUICKSHOP copy keeps the script inline (uid 'qs')
 * because modal HTML arrives after this asset has already executed.
 */
  (function () {
    var root = document.querySelector('[data-bundle-selector]');
    if (!root) return;

    /* ===== Selection state =====
       Schema: { sectionHandle: [variantId, ...] }
       The DOM (checked inputs) is the source of truth — this mirror exists for
       export / future cart-wiring. */
    var state = {};

    function syncSection(sectionEl) {
      var handle = sectionEl.getAttribute('data-bundle-section');
      var ids = [];
      sectionEl.querySelectorAll('[data-bundle-input]').forEach(function (i) {
        if (i.checked) ids.push(i.value);
      });
      state[handle] = ids;
    }

    function syncCardClass(input) {
      var card = input.closest('[data-bundle-option]');
      if (!card) return;
      if (input.checked) card.classList.add('is-checked');
      else card.classList.remove('is-checked');
    }

    // Sold-out options: Liquid only marks them (data-variant-available +
    // aria-disabled + .bundle-option--soldout) — the actual `disabled` is
    // applied contextually. On the PDP nothing sold out can be legitimately
    // checked, so hard-disable here. The drawer copy is gated by
    // cart-drawer.js instead (a checked sold-out add-on already in the cart
    // must stay deselectable there).
    root.querySelectorAll('[data-bundle-input][data-variant-available="false"]').forEach(function (i) {
      i.disabled = true;
    });

    // Initial pass — mirror checked state to cards + state object
    root.querySelectorAll('[data-bundle-section]').forEach(function (sec) {
      sec.querySelectorAll('[data-bundle-input]').forEach(syncCardClass);
      syncSection(sec);
    });

    /* Change handler — enforces selection_type behavior.
       UI is always checkbox; single-choice sections manually uncheck
       siblings here so only one can be checked at a time. */
    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-bundle-input]');
      if (!input) return;
      var section = input.closest('[data-bundle-section]');
      if (!section) return;

      var required = section.getAttribute('data-required') === 'true';
      var selType = section.getAttribute('data-selection-type');

      // single-choice: when a box becomes checked, uncheck every other
      // box in the section. Unchecking still allowed (the required-check
      // below brings it back if the section can't go empty).
      if (selType === 'single' && input.checked) {
        section.querySelectorAll('[data-bundle-input]').forEach(function (other) {
          if (other !== input && other.checked) other.checked = false;
        });
      }

      // is_required: never let a required section end up with zero
      // checked options.
      if (required) {
        var anyChecked = section.querySelectorAll('[data-bundle-input]:checked').length > 0;
        if (!anyChecked) {
          input.checked = true;
        }
      }

      section.querySelectorAll('[data-bundle-input]').forEach(syncCardClass);
      syncSection(section);

      // Broadcast for the cart-wiring layer (assets/bundle-cart.js).
      // Loosely coupled — listeners can subscribe without depending on
      // window.toptureBundleSelector being initialized at any specific time.
      document.dispatchEvent(new CustomEvent('topture:bundle:change', {
        detail: { state: JSON.parse(JSON.stringify(state)) }
      }));
    });

    /* ===== Modal ===== */
    var modal = root.querySelector('[data-bundle-modal]');
    var slot = root.querySelector('[data-bundle-modal-slot]');
    var compareModal = root.querySelector('[data-bundle-compare-modal]');
    var compareSlot = root.querySelector('[data-bundle-compare-slot]');
    var lastFocus = null;
    var lastFocusCompare = null;

    /* iOS-proof scroll lock — `body { overflow: hidden }` alone does not stop
       touch-scroll on iOS Safari. Pin body via position:fixed and restore
       scroll on release. Refcount in case both modals overlap. */
    var scrollLockY = 0;
    var scrollLockCount = 0;
    function lockScroll() {
      if (scrollLockCount === 0) {
        scrollLockY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollLockY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }
      scrollLockCount++;
    }
    function unlockScroll() {
      scrollLockCount = Math.max(0, scrollLockCount - 1);
      if (scrollLockCount === 0) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        // Theme sets `html { scroll-behavior: smooth }` globally — without
        // this override, scrollTo animates back to the previous position,
        // which looks like the page is "scrolling" after the modal closes.
        var html = document.documentElement;
        var prevBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        window.scrollTo(0, scrollLockY);
        html.style.scrollBehavior = prevBehavior;
      }
    }

    function openModal(variantId) {
      var tpl = document.getElementById('bundle-modal-tpl-' + variantId);
      if (!tpl || !slot || !modal) return;
      slot.replaceChildren(tpl.content.cloneNode(true));
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      lastFocus = document.activeElement;
      lockScroll();
      document.body.classList.add('bundle-modal-open');
      var closeBtn = modal.querySelector('.bundle-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      document.body.classList.remove('bundle-modal-open');
      if (slot) slot.replaceChildren();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    /* Phone-only behavior: a single floating header sits above the
       horizontally-scrolling grid and mirrors the active card's image,
       name, and heater-type. The two-container scroll architecture
       (slot vertical, grid horizontal) means mandatory snap can live
       cleanly on the grid without firing during vertical gestures, and
       sticky pinning of the floating head binds to the slot's vertical
       scroll.

       This function consolidates the previous setupMobileCounter and
       setupMobileStuckMode into one pass: a grid-scroll listener
       updates the active-card content + counter, and a slot-scroll
       listener toggles the .bundle-compare--stuck class that fades the
       floating head in once the active card's hero image has scrolled
       off the top of the slot. */
    var mobileGridScroll = null;
    var mobileSlotScroll = null;
    var mobileFloatingActiveIdx = -1;
    function setupMobileFloatingHead() {
      // Teardown any previous listeners (e.g. resize-driven re-init).
      if (mobileGridScroll) {
        var oldGrid = compareModal.querySelector('.bundle-compare__grid');
        if (oldGrid) oldGrid.removeEventListener('scroll', mobileGridScroll);
        mobileGridScroll = null;
      }
      if (mobileSlotScroll) {
        var oldSlot = compareModal.querySelector('.bundle-compare-modal__slot');
        if (oldSlot) oldSlot.removeEventListener('scroll', mobileSlotScroll);
        mobileSlotScroll = null;
      }
      mobileFloatingActiveIdx = -1;
      if (!compareModal) return;

      var slot      = compareModal.querySelector('.bundle-compare-modal__slot');
      var grid      = compareModal.querySelector('.bundle-compare__grid');
      var root      = compareModal.querySelector('.bundle-compare');
      var floating  = compareModal.querySelector('[data-bundle-floating-head]');
      var counterEl = compareModal.querySelector('[data-bundle-counter-current]');
      var cols      = compareModal.querySelectorAll('.bundle-compare__col');
      var images    = compareModal.querySelectorAll('.bundle-compare__col-head .bundle-compare__image');
      if (!slot || !grid || !root || !floating || cols.length < 2) return;

      // Floating head DOM targets — populated by JS as the active card
      // changes. The image and name use simple attribute/text writes;
      // the heater-type clones innerHTML to preserve the inline CSS dot
      // separator span.
      var floatingImg  = floating.querySelector('[data-floating-image]');
      var floatingName = floating.querySelector('[data-floating-name]');
      var floatingType = floating.querySelector('[data-floating-type]');

      var firstLeft = cols[0].offsetLeft;
      var colStep   = cols[1].offsetLeft - firstLeft;
      // Cached: reading clientWidth in the rAF callback would force a
      // layout flush per scroll frame.
      var gridWidth = grid.clientWidth;

      function updateActiveCard() {
        var center = grid.scrollLeft + gridWidth / 2;
        var idx = Math.round((center - firstLeft - colStep / 2) / colStep);
        idx = Math.max(0, Math.min(cols.length - 1, idx));
        // Counter text — write only when changed to avoid layout work.
        if (counterEl) {
          var next = String(idx + 1);
          if (counterEl.textContent !== next) counterEl.textContent = next;
        }
        if (idx === mobileFloatingActiveIdx) return;
        mobileFloatingActiveIdx = idx;
        var card = cols[idx];
        var nameSrc = card.querySelector('.bundle-compare__name');
        var imgSrc  = card.querySelector('.bundle-compare__image img');
        var typeSrc = card.querySelector('.bundle-compare__heater-type');
        if (floatingName && nameSrc) floatingName.textContent = nameSrc.textContent.trim();
        if (floatingImg && imgSrc) {
          floatingImg.src = imgSrc.currentSrc || imgSrc.src;
          floatingImg.alt = imgSrc.alt || '';
        }
        if (floatingType && typeSrc) floatingType.innerHTML = typeSrc.innerHTML;
        floating.classList.toggle(
          'bundle-compare__floating-head--recommended',
          card.classList.contains('bundle-compare__col--recommended')
        );
      }

      // Stuck-mode threshold: where the first card's hero image bottom
      // crosses out of the slot's top viewport (accounting for the
      // sticky counter ~40px). Uses the first card as reference; all
      // cards have identical layout heights for their hero block.
      function computeThreshold() {
        if (!images.length) return 0;
        var imgRect  = images[0].getBoundingClientRect();
        var headEl   = compareModal.querySelector('.bundle-compare__col-head');
        var headRect = headEl ? headEl.getBoundingClientRect() : imgRect;
        var slotRect = slot.getBoundingClientRect();
        var headTopInSlot   = (headRect.top - slotRect.top) + slot.scrollTop;
        var imgBottomInSlot = (imgRect.bottom - slotRect.top) + slot.scrollTop;
        return Math.max(0, imgBottomInSlot - headTopInSlot - 8);
      }
      var threshold = computeThreshold();
      function updateStuck() {
        var stuck = slot.scrollTop >= threshold;
        root.classList.toggle('bundle-compare--stuck', stuck);
      }

      var gridRaf = null;
      mobileGridScroll = function () {
        if (gridRaf) return;
        gridRaf = requestAnimationFrame(function () {
          gridRaf = null;
          updateActiveCard();
        });
      };
      var slotRaf = null;
      mobileSlotScroll = function () {
        if (slotRaf) return;
        slotRaf = requestAnimationFrame(function () {
          slotRaf = null;
          updateStuck();
        });
      };
      grid.addEventListener('scroll', mobileGridScroll, { passive: true });
      slot.addEventListener('scroll', mobileSlotScroll, { passive: true });

      // Initial state: active card = first card, not stuck.
      updateActiveCard();
      updateStuck();

      // Recompute threshold after images load (they may shift layout).
      Promise.all(Array.prototype.map.call(images, function (wrap) {
        var img = wrap.querySelector('img');
        if (!img || img.complete) return Promise.resolve();
        return new Promise(function (r) {
          img.addEventListener('load', r, { once: true });
          img.addEventListener('error', r, { once: true });
        });
      })).then(function () {
        threshold = computeThreshold();
        updateStuck();
      });
    }

    function openCompare(sectionHandle) {
      if (!compareSlot || !compareModal) return;
      var tpl = document.getElementById('bundle-compare-tpl-' + sectionHandle);
      if (!tpl) return;
      compareSlot.replaceChildren(tpl.content.cloneNode(true));
      compareModal.hidden = false;
      compareModal.setAttribute('aria-hidden', 'false');
      lastFocusCompare = document.activeElement;
      lockScroll();
      document.body.classList.add('bundle-compare-open');
      // Floating-head (active-card mirror + counter + stuck-mode) is
      // phone-only; above 720px the cards sit in a responsive grid and
      // the counter + floating head are display:none.
      if (window.matchMedia('(max-width: 720px)').matches) {
        setupMobileFloatingHead();
      }
      var closeBtn = compareModal.querySelector('.bundle-compare-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeCompare() {
      if (!compareModal) return;
      if (mobileSlotScroll) {
        var slotEl = compareModal.querySelector('.bundle-compare-modal__slot');
        if (slotEl) slotEl.removeEventListener('scroll', mobileSlotScroll);
        mobileSlotScroll = null;
      }
      if (mobileGridScroll) {
        var gridEl = compareModal.querySelector('.bundle-compare__grid');
        if (gridEl) gridEl.removeEventListener('scroll', mobileGridScroll);
        mobileGridScroll = null;
      }
      mobileFloatingActiveIdx = -1;
      compareModal.hidden = true;
      compareModal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      document.body.classList.remove('bundle-compare-open');
      if (compareSlot) compareSlot.replaceChildren();
      if (lastFocusCompare && typeof lastFocusCompare.focus === 'function') lastFocusCompare.focus();
    }

    /* Swipe-down-to-close on mobile bottom-sheet. Triggers only from the
       grab-handle, so it never competes with article scrolling. */
    function attachSwipeDown(modalEl, panelSelector, backdropSelector, handleSelector, closeFn) {
      if (!modalEl) return;
      var panel = modalEl.querySelector(panelSelector);
      var handle = modalEl.querySelector(handleSelector);
      var backdrop = modalEl.querySelector(backdropSelector);
      if (!panel || !handle) return;

      var startY = 0;
      var currentY = 0;
      var dragging = false;

      handle.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        dragging = true;
        startY = e.touches[0].clientY;
        currentY = startY;
        // Kill the open-slide keyframe animation (fill-mode: both makes it
        // pin the panel at translateY(0), overriding inline transform and
        // blocking the transition we set in settle()).
        panel.style.animation = 'none';
        panel.style.transition = 'none';
        if (backdrop) {
          backdrop.style.animation = 'none';
          backdrop.style.transition = 'none';
        }
      }, { passive: true });

      handle.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        currentY = e.touches[0].clientY;
        var dy = Math.max(0, currentY - startY);
        panel.style.transform = 'translateY(' + dy + 'px)';
        if (backdrop) {
          var h = panel.offsetHeight || 1;
          backdrop.style.opacity = String(Math.max(0, 1 - (dy / h) * 1.2));
        }
      }, { passive: true });

      function settle() {
        if (!dragging) return;
        dragging = false;
        var dy = Math.max(0, currentY - startY);
        var h = panel.offsetHeight || 1;
        var shouldClose = dy > Math.min(120, h * 0.25);
        panel.style.transition = 'transform 220ms cubic-bezier(0.32, 0.72, 0, 1)';
        if (backdrop) backdrop.style.transition = 'opacity 220ms ease-out';

        if (shouldClose) {
          panel.style.transform = 'translateY(100%)';
          if (backdrop) backdrop.style.opacity = '0';
          var done = function () {
            panel.removeEventListener('transitionend', done);
            closeFn();
            // Restore inline styles so next open re-runs the slide-up keyframe.
            panel.style.transition = '';
            panel.style.transform = '';
            panel.style.animation = '';
            if (backdrop) {
              backdrop.style.transition = '';
              backdrop.style.opacity = '';
              backdrop.style.animation = '';
            }
          };
          panel.addEventListener('transitionend', done);
        } else {
          panel.style.transform = '';
          if (backdrop) backdrop.style.opacity = '';
          var settled = function () {
            panel.removeEventListener('transitionend', settled);
            panel.style.transition = '';
            panel.style.animation = '';
            if (backdrop) {
              backdrop.style.transition = '';
              backdrop.style.animation = '';
            }
          };
          panel.addEventListener('transitionend', settled);
        }
      }

      handle.addEventListener('touchend', settle, { passive: true });
      handle.addEventListener('touchcancel', settle, { passive: true });
    }

    attachSwipeDown(modal, '.bundle-modal__panel', '.bundle-modal__backdrop', '[data-bundle-modal-handle]', closeModal);

    root.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-bundle-modal-open]');
      if (openBtn) {
        e.preventDefault();
        openModal(openBtn.getAttribute('data-bundle-modal-open'));
        return;
      }
      var closeBtn = e.target.closest('[data-bundle-modal-close]');
      if (closeBtn) {
        e.preventDefault();
        closeModal();
        return;
      }
      var selectBtn = e.target.closest('[data-bundle-modal-select]');
      if (selectBtn) {
        e.preventDefault();
        var variantId = selectBtn.getAttribute('data-bundle-modal-select');
        var input = root.querySelector('[data-bundle-input][value="' + variantId + '"]');
        // Sold-out options render their input disabled — refuse the selection
        // (the disabled CTA shouldn't fire, but stale markup must not select).
        if (input && !input.disabled) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        closeModal();
        return;
      }

      var compareOpen = e.target.closest('[data-bundle-compare-open]');
      if (compareOpen) {
        e.preventDefault();
        openCompare(compareOpen.getAttribute('data-bundle-compare-open'));
        return;
      }
      var compareCloseBtn = e.target.closest('[data-bundle-compare-close]');
      if (compareCloseBtn) {
        e.preventDefault();
        closeCompare();
        return;
      }
      var compareSelectBtn = e.target.closest('[data-bundle-compare-select]');
      if (compareSelectBtn) {
        e.preventDefault();
        var cmpVariantId = compareSelectBtn.getAttribute('data-bundle-compare-select');
        var cmpInput = root.querySelector('[data-bundle-input][value="' + cmpVariantId + '"]');
        // Same sold-out refusal as the Learn More modal's select button.
        if (cmpInput && !cmpInput.disabled) {
          cmpInput.checked = true;
          cmpInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        closeCompare();
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (compareModal && !compareModal.hidden) {
        e.preventDefault();
        closeCompare();
        return;
      }
      if (modal && !modal.hidden) {
        e.preventDefault();
        closeModal();
      }
    });

    /* Focus containment for both bundle dialogs (WCAG 2.1.2).
       Both already declare role="dialog" aria-modal="true", move focus in on open,
       and restore it on close via lastFocus / lastFocusCompare. What was missing is
       the tab ring: measured 6 of 12 Tabs escaping the open compare modal into the
       page behind it. aria-modal tells assistive tech the rest is inert; it does
       NOT stop sequential focus for a sighted keyboard user.

       Focusables are recomputed per keypress because both dialogs rebuild their
       contents (replaceChildren / grid re-render) while open, so a cached list
       would reference detached nodes. */
    var MODAL_FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),'
      + 'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

    function openDialogEl() {
      if (compareModal && !compareModal.hidden) return compareModal;
      if (modal && !modal.hidden) return modal;
      return null;
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' && e.keyCode !== 9) return;
      var dlg = openDialogEl();
      if (!dlg) return;
      var items = [].slice.call(dlg.querySelectorAll(MODAL_FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null && el.getAttribute('aria-hidden') !== 'true';
      });
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (!dlg.contains(document.activeElement)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
        return;
      }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Expose for the cart-wiring layer (assets/bundle-cart.js) +
       debugging. The form-submit interceptor lives there so it can read
       state on every submit without coupling to this snippet's IIFE. */
    window.toptureBundleSelector = {
      getState: function () { return JSON.parse(JSON.stringify(state)); },
      _root: root
    };
  })();
